import React from "react";
import CommonProps from "../CommonProps";
import useDataTheme from "../../hooks/UseDataTheme";
import './SchemeToggle.scss';

const SchemeToggle = (props: CommonProps) => {

    const [theme, setTheme] = useDataTheme();
    
    const switchScheme = (): void => {
        if (theme === 'light') {
            setTheme('dark');
        }
        else if (theme === 'dark') {
            setTheme('light');
        }
    }

    return (
        <>
            <div className="scheme-switch-wrapper">
                <label className="scheme-switch" htmlFor="checkbox">
                    <input type="checkbox"
                           id="checkbox"
                           checked={theme === 'dark'}
                           onChange={() => switchScheme()}/>
                    <div className="scheme-slider round"></div>
                </label>
            </div>
        </>
    );
}

export default SchemeToggle;